import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks/hooks";
import {
  handleCognitoRedirect,
  selectIsAuthenticated,
  selectAuthLoading,
} from "store/slices/cognitoAuthSlice";
import { getUserId } from "services/cookieService";
import { fetchUserById } from "store/slices/userSlice";
import { fetchCart } from "store/slices/cartSlice";
import infiniteLoader from "../../assets/loaders/InfinityLoader.gif";
import { openEnquiryDialogue } from "store/slices/enquiryFormSlice";

const CognitoRedirectHandler = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthLoading = useAppSelector(selectAuthLoading);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const [hasHandled, setHasHandled] = useState(
    !!sessionStorage.getItem("cognitoCodeHandled")
  );

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get("code");
    const error = query.get("error");
    const errorDescription = query.get("error_description");

    // Handle Cognito error (e.g., PreSignUp Lambda failed)
    if (error) {
      console.error("Cognito redirect error:", error, errorDescription);
      sessionStorage.removeItem("cognitoCodeHandled");
      navigate(
        `/signin?error=${encodeURIComponent(
          errorDescription || "Authentication failed"
        )}`,
        { replace: true }
      );
      return;
    }

    if (code && !hasHandled && !isAuthLoading && !isAuthenticated) {
      setHasHandled(true);
      sessionStorage.setItem("cognitoCodeHandled", "true");

      dispatch(handleCognitoRedirect()).then(async (action) => {
        if (handleCognitoRedirect.fulfilled.match(action)) {
          const { redirectPath } = action.payload;

          const userId = getUserId();
          if (userId) {
            await dispatch(fetchUserById());
            await dispatch(fetchCart({ userId }));
          }

          const enquiryIntent = localStorage.getItem("bulkEnquiryIntent");
          if (enquiryIntent) {
            const intent = JSON.parse(enquiryIntent);
            dispatch(
              openEnquiryDialogue({
                products: intent.products,
                quantities: intent.quantities,
              })
            );
          }

          sessionStorage.removeItem("cognitoCodeHandled");
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );
          navigate(redirectPath, { replace: true });
        } else {
          console.error("Redirect authentication failed:", action.payload);
          sessionStorage.removeItem("cognitoCodeHandled");
          navigate("/signin?error=redirect_failed", { replace: true });
        }
      });
    }
  }, [
    dispatch,
    location.search,
    isAuthLoading,
    isAuthenticated,
    hasHandled,
    navigate,
  ]);

  return (
    <div className="w-full h-screen flex items-center justify-center bg-white dark:bg-slate-900">
      <img src={infiniteLoader} alt="Loading..." className="w-1/6" />
    </div>
  );
};

export default CognitoRedirectHandler;
